import React from 'react';
import cx from 'classnames';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from '../../styles/HeaderCellSort.module.scss';

type Props = {
    componentClasses?: string;
    isDesc?: boolean;
    onClick: (e) => void;
    disabled?: boolean;
};

export const HeaderCellSort = (props: Props) => {
    const {componentClasses, isDesc, onClick, disabled} = props;

    return (
        <Icon
            onClick={onClick}
            componentClasses={cx(styles.icon, componentClasses, {
                [styles.isDesc]: isDesc
            })}
            icon={PriorityIcon.sorted}
            disabled={disabled}
        />
    );
};
